export default "__VITE_ASSET__058dd0c6__"